/* eslint-disable @angular-eslint/directive-selector */
import { Directive, Input } from '@angular/core';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { get, isObject } from 'lodash';

@Directive({
  selector: 'mat-autocomplete',
  standalone: true,
})
export class MatAutocompleteAddonsDirective {
  @Input() get displayWithPath() {
    return this._displayWithPath;
  }
  set displayWithPath(path: string) {
    this.matAutocomplete.displayWith = (entity: unknown) =>
      isObject(entity) ? get(entity, path) : '';
  }

  private _displayWithPath!: string;

  constructor(private readonly matAutocomplete: MatAutocomplete) {}
}
